// extracted by mini-css-extract-plugin
export default {"productsTable":"ProductsTable_productsTable__rFlH0"};